import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0108',
    ecrans: ['00-2'],
    params: ['stamnetab', 'cpecleintref', '?trncleint']
});
